import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import Header from "../components/Header";
import Layout from "../components/Layout";
import styled from "styled-components";
import Drawer from "../components/Drawer";
import { useState } from "react";
import Alert from "../components/Alert";
import Video from "../components/Video";
import {
  deleteVideo,
  getAllAlerts,
  getManagerVideos,
  openVideos,
  searchAlerts,
} from "../actions/alertActions";
import { format } from "date-fns";
import Users from "../components/Users";
import UserDetails from "../components/UserDetails";
import { COLORS } from "../contants/colors";
import Spinner from "react-bootstrap/Spinner";
import Search from "../components/Search";
import ToastContainer from "react-bootstrap/esm/ToastContainer";
import Collapse from "react-bootstrap/Collapse";
import Toast from "react-bootstrap/Toast";
import { useLanguageContext } from "../languageContext";
import ShareVideo from "../components/ShareVideo";
import { createNews } from "../actions/newsActions";

const VideosScreen = ({ history }) => {
  const [selected, setSelected] = useState(11);
  const [selectedParticipants, setSelectedParticipants] = useState([]);
  const [selectedDisapprovers, setSelectedDisapprovers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [yPosition, setYPosition] = useState(0);
  const [openDrawer, setOpenDrawer] = useState(false);
  const { userInfo } = useSelector((state) => state.userLogin);
  const { videos, count_video, loading } = useSelector((state) => state.video);
  const { error } = useSelector((state) => state.news);

  const [keyword, setKeyword] = useState("");
  const [message, setMessage] = useState("");
  const [toastType, setToastType] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [showSharePopup, setShowSharePopup] = useState(false);
  const [selectedVideo, setSelectedVideo] = useState(null);

  const dispatch = useDispatch();
  const { t } = useLanguageContext();

  const onShareVideo = (title, description, callback) => {
    dispatch(
      createNews(
        userInfo.token,
        title,
        description,
        selectedVideo.link, //media
        "", //live url
        "",
        "",
        "",
        "",
        selectedVideo.sportBelonging ?? [],
        selectedVideo.politicBelonging ?? [],
        selectedVideo.defaultBelonging ?? [],
        "", //selectedVideo.longitude,
        "", //selectedVideo.latitude,
        "",
        "",
        t("newNews"),
        () => {
          callback();
          setMessage(t("successShareVideo"));
          setToastType("success");
        }
      )
    );
  };

  const onSearchVideos = () => {
    dispatch(
      searchAlerts(
        userInfo["token"],
        keyword,
        startDate,
        endDate,
        userInfo["_id"],
        "video"
      )
    );
  };

  useEffect(() => {
    if (userInfo) {
      // dispatch(openVideos(userInfo["token"]));
      if (userInfo.isVideosManager) {
        dispatch(
          getManagerVideos(
            userInfo.token,
            keyword,
            startDate,
            endDate,
            userInfo._id
          )
        );
      } else
        dispatch(getAllAlerts(userInfo["token"], userInfo["_id"], "video"));
    }

    return () => {
      dispatch(openVideos(userInfo["token"]));
    };
  }, []);
  // useEffect(() => {
  //   dispatch(openVideos(userInfo["token"]));
  // }, [count_video]);

  const onDeleteVideo = (id) => {
    dispatch(deleteVideo(userInfo["token"], id));
  };

  useEffect(() => {
    if (error) {
      setMessage(t("mainError"));
      setToastType("danger");
    }
  }, [error]);

  useEffect(() => {
    setTimeout(() => {
      setToastType("");
    }, 8000);
  }, [toastType]);

  useEffect(() => {
    if (keyword !== "" || startDate !== "" || endDate !== "") {
      if (userInfo.isVideosManager) {
        dispatch(
          getManagerVideos(
            userInfo.token,
            keyword,
            startDate,
            endDate,
            userInfo._id
          )
        );
      } else onSearchVideos();
    }
    if (keyword === "" && startDate === "" && endDate === "") {
      if (userInfo.isVideosManager) {
        dispatch(
          getManagerVideos(
            userInfo.token,
            keyword,
            startDate,
            endDate,
            userInfo._id
          )
        );
      } else
        dispatch(getAllAlerts(userInfo["token"], userInfo["_id"], "video"));
    }
  }, [keyword, startDate, endDate]);

  return (
    <div style={{ position: "relative" }}>
      {selectedUser && (
        <UserDetails
          user={selectedUser}
          onClose={() => setSelectedUser(null)}
          top={yPosition}
          hideNestedData={true}
        />
      )}
      {showSharePopup && (
        <ShareVideo
          video={selectedVideo}
          onShareNews={(id, title, description, callback) =>
            onShareVideo(title, description, callback)
          }
          onClose={() => setShowSharePopup(false)}
        />
      )}
      <Layout>
        <Header
          onClickNotification={(user) => setSelectedUser(user)}
          setOpenDrawer={() => setOpenDrawer(!openDrawer)}
        />
        <Drawer
          setOpenDrawer={() => setOpenDrawer(!openDrawer)}
          open={openDrawer}
          history={history}
          selected={selected}
          onChange={(value) => setSelected(value)}
        />
        <Body>
          {(selectedParticipants.length || selectedDisapprovers.length > 0) && (
            <Users
              data={
                selectedParticipants.length > 0
                  ? selectedParticipants
                  : selectedDisapprovers
              }
              title={
                selectedParticipants.length > 0 ? t("helpers") : t("naysayers")
              }
              onCloseUsersList={() => {
                setSelectedParticipants([]);
                setSelectedDisapprovers([]);
              }}
              onClick={(user, event) => {
                // window.pageYOffset
                setYPosition(window.pageYOffset);
                setSelectedUser(user);
                setSelectedParticipants([]);
                setSelectedDisapprovers([]);
              }}
            />
          )}
          <Search
            states={[]}
            dropdownTitle={t("state")}
            hint={t("search")}
            onSearch={() => {
              if (keyword !== "") {
                if (userInfo.isVideosManager)
                  dispatch(
                    getManagerVideos(
                      userInfo.token,
                      keyword,
                      startDate,
                      endDate,
                      userInfo._id
                    )
                  );
                else onSearchVideos();
              } else if (startDate !== "" || endDate !== "") {
                if (userInfo.isVideosManager)
                  dispatch(
                    getManagerVideos(
                      userInfo.token,
                      keyword,
                      startDate,
                      endDate,
                      userInfo._id
                    )
                  );
                else onSearchVideos();
              }
            }}
            onChange={(value) => {
              setKeyword(value);
            }}
            onChangeEndDate={(value) => {
              if (!isNaN(new Date(value).getDate())) {
                if (new Date(value) <= new Date(startDate)) {
                  setMessage(t("startGt"));
                  setToastType("danger");
                } else setEndDate(new Date(value));
              }
            }}
            onChangeStartDate={(value) => {
              if (!isNaN(new Date(value).getDate())) {
                if (new Date(value) >= new Date(endDate)) {
                  setMessage(t("startLt"));
                  setToastType("danger");
                } else setStartDate(new Date(value));
              }
            }}
            onClearFilters={() => {
              if (userInfo.isVideosManager)
                dispatch(
                  getManagerVideos(
                    userInfo.token,
                    keyword,
                    startDate,
                    endDate,
                    userInfo._id
                  )
                );
              else onSearchVideos("", "", "");
              setStartDate("");
              setEndDate("");
            }}
          />
          {!loading
            ? videos.length === 0 && <Empty>{t("noAlerts")}</Empty>
            : null}

          <Grid>
            {loading ? (
              <div
                style={{
                  display: "flex",
                  justifyContent: "end",
                  alignItems: "center",
                  height: "100vh",
                }}
              >
                <Spinner animation="border" variant="primary" size="xl" />
              </div>
            ) : (
              videos.map((alert, i) =>
                alert["sender"] ? (
                  <Video
                    canDelete={!userInfo.isVideosManager}
                    isHighlighted={i < count_video}
                    showShare={userInfo.isVideosManager}
                    showSharePopup={showSharePopup}
                    photo={alert["sender"]["image"]}
                    username={
                      alert["sender"]["name"] +
                      " " +
                      alert["sender"]["familyName"]
                    }
                    address={alert["county"]}
                    time={format(
                      new Date(alert["createdAt"]),
                      "HH:mm - dd/MM/yyyy"
                    )}
                    media={alert["link"]}
                    onDelete={() => onDeleteVideo(alert["_id"])}
                    onShare={() => {
                      setShowSharePopup(!showSharePopup);
                      setSelectedVideo(alert);
                    }}
                  />
                ) : null
              )
            )}
          </Grid>
          {toastType !== "" && (
            <ToastContainer
              containerPosition="sticky"
              position="top-end"
              style={{
                position: "fixed !important",
                bottom: "40%",
                right: 0,
                zIndex: "2000",
                float: "right",
                textAlign: "left",
              }}
            >
              <Toast
                delay={7000}
                animation
                transition={Collapse}
                bg={toastType}
                style={{
                  borderRadius: "4px",
                  fontFamily: "Din",
                  padding: "0 30px",
                }}
              >
                <Toast.Body className={"text-white"}>{message}</Toast.Body>
              </Toast>
            </ToastContainer>
          )}
        </Body>
      </Layout>
    </div>
  );
};

const Body = styled.div`
  padding: 3vw 28px;
`;

const Grid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(333px, 1fr));
  grid-row-gap: 17px;
  grid-column-gap: 24px;
  margin-top: 20px;
`;
const Empty = styled.p`
  color: ${COLORS.gray400};
  font-family: "Din";
  font-weight: 400;
  font-size: 0.9rem;
  text-align: center;
  align-self: center;
  margin-top: 30vh;
`;
export default VideosScreen;
